module.exports = __webpack_public_path__ + "static/media/artisan-alliance.4eb0d09d.png";